import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import { useI18n } from '../i18n/I18nContext';
import './AppointmentModal.css';

function AppointmentModal() {
  const { isOpen, closeModal } = useAppointmentModal();
  const { lang, copy } = useI18n();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    website: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const openedAtRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      openedAtRef.current = Date.now();
      setFormData({ name: '', phone: '', email: '', website: '' });
      setSubmitStatus(null);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('/api/termin.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          website: formData.website,
          ts: openedAtRef.current,
          lang
        })
      });

      let data = null;
      try {
        data = await response.json();
      } catch {
        data = null;
      }

      if (response.ok && data && data.ok === true) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', website: '' });
        setTimeout(() => {
          closeModal();
          setSubmitStatus(null);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Fehler beim Senden der Terminanfrage:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="appointment-modal-overlay" onClick={handleOverlayClick}>
      <div className="appointment-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="appointment-modal-close"
          onClick={closeModal}
          aria-label={copy.modal.close}
        >
          ×
        </button>

        <h2 className="appointment-modal-title">{copy.modal.title}</h2>
        <p className="appointment-modal-subtitle">
          {copy.modal.subtitle}
        </p>

        <form onSubmit={handleSubmit} className="appointment-modal-form">
          <div className="appointment-modal-form-group">
            <label htmlFor="name" className="appointment-modal-label">
              {copy.modal.name}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="appointment-modal-input"
              placeholder={copy.modal.namePlaceholder}
            />
          </div>

          <div className="appointment-modal-form-group">
            <label htmlFor="phone" className="appointment-modal-label">
              {copy.modal.phone}
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="appointment-modal-input"
              placeholder={copy.modal.phonePlaceholder}
            />
          </div>

          <div className="appointment-modal-form-group">
            <label htmlFor="email" className="appointment-modal-label">
              {copy.modal.email}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="appointment-modal-input"
              placeholder={copy.modal.emailPlaceholder}
            />
          </div>

          <div className="appointment-modal-honeypot" aria-hidden="true">
            <label htmlFor="website">{copy.modal.website}</label>
            <input
              type="text"
              id="website"
              name="website"
              value={formData.website}
              onChange={handleChange}
              tabIndex={-1}
              autoComplete="off"
            />
          </div>

          {submitStatus === 'success' && (
            <div className="appointment-modal-message appointment-modal-message-success">
              {copy.modal.success}
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="appointment-modal-message appointment-modal-message-error">
              {copy.modal.error}
            </div>
          )}

          <p className="appointment-modal-privacy">
            {copy.modal.privacyBefore}{' '}
            <Link to={lang === 'en' ? '/en/privacy' : '/datenschutz'} onClick={closeModal}>{copy.modal.privacyLink}</Link>
            {copy.modal.privacyAfter}
          </p>

          <button
            type="submit"
            className="appointment-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? copy.modal.sending : copy.modal.send}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AppointmentModal;
